<template>
    <div class="flex flex-col w-full lg:w-11/12 ml-auto mr-auto sm:p-12 mt-20 mb-12 justify-around items-center relative">
        <div class="flex flex-col sm:flex-row  w-full lg:w-11/12 justify-between items-center">
            <h1 class="text-3xl sm:text-46 font-trap text-center">Our Life</h1>
            <div class="flex sm:hidden mt-3 gap-7">
                <button class="font-semibold" :class="{
                    'text-mainColor': isSportVisible,
                    'text-grayCase': !isSportVisible,
                }" @click="showSport">
                    Sort
                </button>
                <button class=" font-semibold" :class="{
                    'text-mainColor': isEntertainmentVisible,
                    'text-grayCase': !isEntertainmentVisible,
                }" @click="showEntertainment">
                    Entertainment
                </button>
                <button class=" font-semibold" :class="{
                    'text-mainColor': isLiveVisible,
                    'text-grayCase': !isLiveVisible,
                }" @click="showLive">
                    Live
                </button>

            </div>
            <div class="sm:block hidden">
                <button class="w-24  lg:w-32 text-sm" :class="{
                    'btn-primary': isSportVisible,
                    'default-awards': !isSportVisible,
                }" @click="showSport">
                    SPORT
                </button>
                <button class="w-44  ml-3 text-sm h-14" :class="{
                    'btn-primary': isEntertainmentVisible,
                    'default-awards': !isEntertainmentVisible,
                }" @click="showEntertainment">
                    ENTERTAINMENT
                </button>
                <button class="w-20  lg:w-32 ml-3 text-sm h-14" :class="{
                    'btn-primary': isLiveVisible,
                    'default-awards': !isLiveVisible,
                }" @click="showLive">
                    LIFE
                </button>
            </div>
        </div>
        <div
            class="blue-rectangle 2xl:w-full sm:rounded-[40px] rounded-[20px] flex h-20 sm:h-64 2xl:bottom-36 bottom-16 sm:bottom-40 xl:bottom-32 items-center justify-end w-[110%] sm:w-full absolute">
        </div>
        <div v-show="isSportVisible" id="indicators-carousel" class="relative w-full" data-carousel="slide"
            data-carousel-interval="5000">
            <div ref="carousel" id="carousel"
                class="relative xl:h-[700px] 2xl:h-780 lg:h-600 overflow-hidden sm:h-[400px] h-64 md:h-[500px]">
                <div id="carousel-item-1" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item="active">
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
                <div id="carousel-item-2" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item>
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
                <div id="carousel-item-3" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item>
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
                <div id="carousel-item-4" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item>
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
            </div>
            <div class="flex carousel-arrows items-center sm:mt-8 space-x-12 justify-center">
                <button
                    class="border border-grayBorder hover:border-mainColor rounded-full flex items-center justify-center w-14 h-14 cursor-pointer group focus:outline-none transition duration-200"
                    data-carousel-prev>
                    <svg aria-hidden="true" class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6"
                        fill="none" stroke="currentColor" stroke-width="{1.5}" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"></path>
                    </svg>
                </button>
                <div class="flex space-x-3 justify-center">
                    <button id="carousel-indicator-1" class="slider" aria-current="true" aria-label="Slide 1"
                        data-carousel-slide-to="0"></button>
                    <button id="carousel-indicator-2" class="slider" aria-current="false" aria-label="Slide 2"
                        data-carousel-slide-to="1"></button>
                    <button id="carousel-indicator-3" class="slider" aria-current="false" aria-label="Slide 3"
                        data-carousel-slide-to="2"></button>
                    <button id="carousel-indicator-4" class="slider" aria-current="false" aria-label="Slide 4"
                        data-carousel-slide-to="3"></button>
                </div>
                <button
                    class="border border-grayBorder hover:border-mainColor rounded-full flex items-center justify-center w-14 h-14 cursor-pointer transition duration-200 group focus:outline-none"
                    data-carousel-next>
                    <svg aria-hidden="true" class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6"
                        fill="none" stroke="currentColor" stroke-width="{1.5}" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></path>
                    </svg>
                </button>
            </div>
        </div>

        <div v-show="isEntertainmentVisible" id="indicators-carousel-2" class="relative w-full" data-carousel="static"
            data-carousel-interval="5000">
            <div ref="carousel" id="carousel-2"
                class="relative xl:h-[700px] 2xl:h-780 lg:h-600 overflow-hidden sm:h-[400px] h-64 md:h-[500px]">
                <div id="carousel-item-1" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item="active">
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
                <div id="carousel-item-2" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item>
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
                <div id="carousel-item-3" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item>
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
                <div id="carousel-item-4" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item>
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
            </div>
            <div class="flex carousel-arrows items-center sm:mt-8 space-x-12 justify-center">
                <button
                    class="border border-grayBorder hover:border-mainColor rounded-full flex items-center justify-center w-14 h-14 cursor-pointer group focus:outline-none transition duration-200"
                    data-carousel-prev>
                    <svg aria-hidden="true" class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6"
                        fill="none" stroke="currentColor" stroke-width="{1.5}" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"></path>
                    </svg>
                </button>
                <div class="flex space-x-3 justify-center">
                    <button id="carousel-indicator-1" class="slider" aria-current="true" aria-label="Slide 1"
                        data-carousel-slide-to="0"></button>
                    <button id="carousel-indicator-2" class="slider" aria-current="false" aria-label="Slide 2"
                        data-carousel-slide-to="1"></button>
                    <button id="carousel-indicator-3" class="slider" aria-current="false" aria-label="Slide 3"
                        data-carousel-slide-to="2"></button>
                    <button id="carousel-indicator-4" class="slider" aria-current="false" aria-label="Slide 4"
                        data-carousel-slide-to="3"></button>
                </div>
                <button
                    class="border border-grayBorder hover:border-mainColor rounded-full flex items-center justify-center w-14 h-14 cursor-pointer transition duration-200 group focus:outline-none"
                    data-carousel-next>
                    <svg aria-hidden="true" class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6"
                        fill="none" stroke="currentColor" stroke-width="{1.5}" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></path>
                    </svg>
                </button>
            </div>
        </div>
        <div v-show="isLiveVisible" id="indicators-carousel-3" class="relative w-full" data-carousel="static"
            data-carousel-interval="5000">
            <div ref="carousel" id="carousel-3"
                class="relative xl:h-[700px] 2xl:h-780 lg:h-600 overflow-hidden sm:h-[400px] h-64 md:h-[500px]">
                <div id="carousel-item-1" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item="active">
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
                <div id="carousel-item-2" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item>
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
                <div id="carousel-item-3" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item>
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
                <div id="carousel-item-4" class="duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                    data-carousel-item>
                    <div class="flex relative items-center md:py-12 2xl:w-11/12 flex-col-reverse md:flex-row">
                        <img alt="slider" class="2xl:w-full lazyload" data-src="../../../images/sport-slide.jpg" />
                    </div>
                </div>
            </div>
            <div class="flex carousel-arrows items-center sm:mt-8 space-x-12 justify-center">
                <button
                    class="border border-grayBorder hover:border-mainColor rounded-full flex items-center justify-center w-14 h-14 cursor-pointer group focus:outline-none transition duration-200"
                    data-carousel-prev>
                    <svg aria-hidden="true" class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6"
                        fill="none" stroke="currentColor" stroke-width="{1.5}" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"></path>
                    </svg>
                </button>
                <div class="flex space-x-3 justify-center">
                    <button id="carousel-indicator-1" class="slider" aria-current="true" aria-label="Slide 1"
                        data-carousel-slide-to="0"></button>
                    <button id="carousel-indicator-2" class="slider" aria-current="false" aria-label="Slide 2"
                        data-carousel-slide-to="1"></button>
                    <button id="carousel-indicator-3" class="slider" aria-current="false" aria-label="Slide 3"
                        data-carousel-slide-to="2"></button>
                    <button id="carousel-indicator-4" class="slider" aria-current="false" aria-label="Slide 4"
                        data-carousel-slide-to="3"></button>
                </div>
                <button
                    class="border border-grayBorder hover:border-mainColor rounded-full flex items-center justify-center w-14 h-14 cursor-pointer transition duration-200 group focus:outline-none"
                    data-carousel-next>
                    <svg aria-hidden="true" class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6"
                        fill="none" stroke="currentColor" stroke-width="{1.5}" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></path>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AboutUsCarousel",
    data() {
        return {
            isSportVisible: true,
            isEntertainmentVisible: false,
            isLiveVisible: false,
        };
    },
    methods: {
        showSport() {
            this.isSportVisible = true;
            this.isEntertainmentVisible = false;
            this.isLiveVisible = false;
        },
        showEntertainment() {
            this.isSportVisible = false;
            this.isLiveVisible = false;
            this.isEntertainmentVisible = true;
        },
        showLive() {
            this.isSportVisible = false;
            this.isLiveVisible = true;
            this.isEntertainmentVisible = false;
        },
    },
};
</script>
